import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SERVICE, AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { User } from '../models/user';

export const accountCompletedGuard: CanActivateFn = async (route, state) => {

  const authService = inject(AUTH_SERVICE);
  const router = inject(Router);

  let user = authService.user();

  if (!user) {
    user = await authService.getUser();
  }

  if (user?.account_registered && user?.terms_accepted && user?.policies_accepted) {
    return true;
  }

  return router.parseUrl('/complete-account'); 

};
